module.exports = __webpack_public_path__ + "static/media/plus5.cd2fb875.jpg";